var map = {
	"./img/for-example/cute-beetroot.png": 5321,
	"./img/for-example/cute-cartoon-green-peas.png": 4277,
	"./img/for-example/happy-corn.png": 3054,
	"./img/for-example/smiling-carrot.png": 1052,
	"./img/products/mezuza.webp": 6781,
	"./img/products/tfiling.jpg": 286,
	"./img/stories/contemplative-reptile.jpg": 9303,
	"./logo/Chabad-logo.jpeg": 3750,
	"./logo/Chabad-logo.png": 6041,
	"./logo/Chabad-logo.psd": 3752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;